import { Navigate, type RouteObject } from 'react-router-dom';

import { ROUTE_CONSTANTS, routes } from '../constants/routes';

import { MainLayout } from './_layout/main';
import { SecurityFocusesRoute } from './security-focuses';
import { FocusIDRoute } from './security-focuses/$focusID';
import { FocusSpidrIDRoute } from './security-focuses/$focusID/spidrs/$spidrID';
import { SpidrLibraryRoute } from './spidr-library';
import { AllSpidrsRoute } from './spidr-library/all';
import { ExcludedRoute } from './spidr-library/excluded';
import { FavoritesRoute } from './spidr-library/favorites';
import { IncludedRoute } from './spidr-library/included';
import { SpidrIDRoute } from './spidrs/$spidrID';

import '@rtkwlf/c3-core-css';
import '@rtkwlf/c3-recipes-timeline/css';

export const securityJourneyRoutes = {
  path: `/${ROUTE_CONSTANTS.SECURITY_JOURNEY}`,
  element: <MainLayout />,
  children: [
    {
      index: true,
      element: <Navigate to={routes.securityFocuses.index()} />,
    },
    {
      path: ROUTE_CONSTANTS.SECURITY_FOCUSES,
      children: [
        {
          ...SecurityFocusesRoute,
          index: true,
        },
        {
          path: ROUTE_CONSTANTS.FOCUS_ID,
          children: [
            {
              ...FocusIDRoute,
              index: true,
            },
            {
              path: ROUTE_CONSTANTS.SPIDRS,
              children: [
                {
                  index: true,
                  element: <div>404</div>,
                },
                {
                  ...FocusSpidrIDRoute,
                  path: ROUTE_CONSTANTS.SPIDR_ID,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: ROUTE_CONSTANTS.SPIDR_LIBRARY,
      ...SpidrLibraryRoute,
      children: [
        {
          index: true,
          // set the default route to all spidrs
          element: <Navigate to={routes.spidrLibrary.all.index()} />,
        },
        {
          ...AllSpidrsRoute,
          path: ROUTE_CONSTANTS.ALL,
        },
        {
          ...IncludedRoute,
          path: ROUTE_CONSTANTS.INCLUDED,
        },
        {
          ...ExcludedRoute,
          path: ROUTE_CONSTANTS.EXCLUDED,
        },
        {
          ...FavoritesRoute,
          path: ROUTE_CONSTANTS.FAVORITES,
        },
      ],
    },
    {
      path: ROUTE_CONSTANTS.SPIDRS,
      children: [
        {
          ...SpidrIDRoute,
          path: `${ROUTE_CONSTANTS.SPIDR_ID}`,
        },
      ],
    },
  ],
} satisfies RouteObject;
